import React from "react";
import EnsaConstant from "./EnsaConstant";

const ChartSkGender = ({ dataLiterasi }) => {
    require("./Ensa.css");
    return (
        <div className="card-skGen">
            {dataLiterasi.map((item) =>
                <div style={{
                    backgroundColor: item.nama == 'Mandiri' ? '#F97316'
                        : item.nama == 'Kritis' ? '#5446CD'
                            : item.nama == 'Beriman' ? '#03C46B'
                                : item.nama == 'Berkebhinekaan' ? '#FEBC04'
                                    : item.nama == 'Kreatif' ? '#015E56'
                                        : '#FF3838'
                }}>
                    <div className="chart-label" style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>{item.nama}</div>
                    {item.listData.map((itemKat) =>
                        <div className="label-gender" style={{height: itemKat.skor + 'px'}}>{itemKat.kategori}</div>
                    )}
                </div>
            )}
        </div>

    );
};

export default ChartSkGender;
